import { forwardRef, Ref, SVGAttributes } from 'react';
interface Props extends React.SVGProps<SVGSVGElement> {
  path1Color?: string;
  path2Color?: string;
  path3Color?: string;
  path4Color?: string;
}
const CartIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  const {
    path1Color = '#fff',
    path2Color = '#fff',
    path3Color = '#fff',
    path4Color = '#fff',
    ...restProps
  } = props;
  return <svg viewBox="0 0 48 48" height={20} width={20} fill="none" ref={ref} {...restProps}>
      <path d="M20 44.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8" fill={path1Color} />
      <path d="M12.3 17.8a2 2 0 0 1-1.89-1.3l-2.82-8H3a2 2 0 1 1 0-4h6a2 2 0 0 1 1.88 1.33l3.3 9.3a2 2 0 0 1-1.88 2.67" fill={path2Color} />
      <path d="M41.42 33.5H16.51a2 2 0 0 1-1.92-1.45L9 12.5h36.47a2 2 0 0 1 1.95 2.46l-4 17a2 2 0 0 1-2 1.54" fill={path3Color} />
      <path d="M38 44.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8" fill={path4Color} />
    </svg>;
});
export default CartIcon;